<template>
  <div class="school-manage">
    <el-tabs v-model="activeTab" type="card" @tab-click="tabChange">
      <el-tab-pane label="学校基础信息" name="info">
        <SchoolInfo class="tableName" ref="schoolInfo" style="width: 100%;"/>
      </el-tab-pane>
      <el-tab-pane label="教师管理"  name="user">
        <SchoolUser ref="schoolUser" class="tableName" />
      </el-tab-pane>
      <el-tab-pane label="班级管理" name="class">
        <SchoolClass ref="schoolClass"  class="tableName"/>
      </el-tab-pane>
      
      <!-- 🔥 新增：任职管理 -->
      <el-tab-pane label="任职管理" name="job">
        <SchoolJob ref="schoolJob" class="tableName"/>
      </el-tab-pane>
	  <el-tab-pane label="校区管理" name="schoolArea">
	    <SchoolArea ref="schoolArea" class="tableName"/>
	  </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SchoolInfo from './components/SchoolInfo.vue'
import SchoolUser from './components/SchoolUser.vue'
import SchoolClass from './components/SchoolClass.vue'
import SchoolJob from './components/SchoolJob.vue' // 新增
import SchoolArea from './components/SchoolArea.vue' // 新增

export default {
  name: 'SchoolManage',
  components: {
    SchoolInfo,
    SchoolUser,
    SchoolClass,
    SchoolJob, // 新增
	SchoolArea
  },
  data() {
    return {
      activeTab: 'info'
    }
  },
  created() {
  	// this.tabChange()
  },
  mounted() {
    // 等待 DOM 完全渲染后再调用
    this.tabChange()
  },
  methods: {
	  
    tabChange() {
      if (this.activeTab === 'info') {
        this.$refs.schoolInfo.getSchoolInfo()
      } else if (this.activeTab === 'user') {
        this.$refs.schoolUser.getList()
      } else if (this.activeTab === 'class') {
          this.$nextTick(() => {
			  
            this.$refs.schoolClass.getGradeTree()
          })
      } else if (this.activeTab === 'job') {
        this.$refs.schoolJob.selectJob() // 新增
      }else if(this.activeTab === 'schoolArea'){
		  this.$refs.schoolArea.getList() // 新增
	  }
    }
  }
}
</script>

<style scoped>
.school-manage {
  position: relative;
  height: calc(100vh - 72px);
  min-height: 680px;
  padding: 22px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  background:
    radial-gradient(circle at 9% 16%, rgba(82, 196, 183, 0.22), transparent 28%),
    radial-gradient(circle at 88% 9%, rgba(255, 190, 92, 0.22), transparent 25%),
    linear-gradient(135deg, #f7fbff 0%, #eef6ff 42%, #f8fbf5 100%);
}

/* 2026-07-17 School management style: playful but restrained campus background. */
.school-manage::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(42, 115, 183, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(42, 115, 183, 0.05) 1px, transparent 1px);
  background-size: 28px 28px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.92), rgba(0, 0, 0, 0.18));
}

.school-manage::after {
  content: "";
  position: absolute;
  right: 32px;
  bottom: 28px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  pointer-events: none;
  background:
    radial-gradient(circle at 50% 50%, rgba(64, 158, 255, 0.11) 0 34%, transparent 36%),
    conic-gradient(from 28deg, rgba(103, 194, 58, 0.16), rgba(255, 190, 92, 0.12), rgba(64, 158, 255, 0.12), rgba(103, 194, 58, 0.16));
  filter: blur(0.2px);
  opacity: 0.8;
}

::v-deep .el-tabs {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(159, 190, 220, 0.42);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 42px rgba(30, 72, 120, 0.12);
  backdrop-filter: blur(12px);
}

::v-deep .el-tabs__header {
  margin: 0 0 16px;
  border-bottom: 0;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  border: 0;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  border: 1px solid #dce8f5;
  border-radius: 10px;
  color: #516477;
  background: #f8fbff;
  font-weight: 600;
  letter-spacing: 0;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item:hover {
  color: #2369b2;
  background: #eef7ff;
  transform: translateY(-1px);
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  color: #ffffff;
  border-color: #2f8ce5;
  background: linear-gradient(135deg, #2f8ce5, #28b3a8);
  box-shadow: 0 10px 20px rgba(47, 140, 229, 0.22);
}

::v-deep .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

::v-deep .el-tab-pane {
  min-height: 100%;
  box-sizing: border-box;
}

/* 2026-07-17 School management style: normalize child page containers without touching logic. */
::v-deep .school-user,
::v-deep .school-class-page,
::v-deep .school-job-container,
::v-deep .app-container {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
}

::v-deep .school-user,
::v-deep .school-class-page,
::v-deep .school-job-container .layout {
  min-height: 100%;
  height: auto !important;
}

::v-deep .el-tab-pane > .el-card,
::v-deep .app-container {
  min-height: 100%;
}

::v-deep .el-card,
::v-deep .table-box,
::v-deep .right-content,
::v-deep .head-container {
  border-radius: 12px;
  border: 1px solid #e4edf7;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(31, 74, 118, 0.08);
}

::v-deep .el-card {
  border-color: #e1ecf6;
}

::v-deep .el-card__body {
  padding: 20px;
}

::v-deep .tool-box,
::v-deep .btn-group,
::v-deep .title-box,
::v-deep .head-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 14px;
  padding: 12px;
}

::v-deep .table-box {
  padding: 12px;
}

::v-deep .page-box {
  margin-top: 14px;
  padding: 10px 4px 0;
  text-align: right;
}

::v-deep .left-tree,
::v-deep .left-menu {
  border: 1px solid #dfeaf6;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff, #f7fbff);
  box-shadow: 0 10px 24px rgba(31, 74, 118, 0.08);
}

::v-deep .left-tree {
  padding: 12px;
}

::v-deep .left-menu {
  width: 184px;
  padding: 12px;
  border-right: 1px solid #dfeaf6;
}

::v-deep .school-job-container .right-content,
::v-deep .school-class-page .right-content {
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

::v-deep .menu-item {
  border-radius: 10px;
  color: #516477;
  font-weight: 600;
}

::v-deep .menu-item.active {
  background: linear-gradient(135deg, #2f8ce5, #28b3a8);
  box-shadow: 0 8px 16px rgba(47, 140, 229, 0.2);
}

::v-deep .menu-item:hover:not(.active) {
  color: #2369b2;
  background: #eef7ff;
}

::v-deep .el-button {
  border-radius: 9px;
  font-weight: 600;
}

::v-deep .el-button--primary {
  background: #2f8ce5;
  border-color: #2f8ce5;
}

::v-deep .el-button--success {
  background: #28a986;
  border-color: #28a986;
}

::v-deep .el-table {
  border-radius: 10px;
  overflow: hidden;
}

::v-deep .el-table th {
  background: #f1f7ff;
  color: #2f4154;
  font-weight: 700;
}

::v-deep .el-table td,
::v-deep .el-table th {
  border-color: #e8f0f8;
}

::v-deep .el-table__row:hover > td {
  background: #f7fbff !important;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-select .el-input__inner {
  border-radius: 9px;
  border-color: #d9e6f3;
}

::v-deep .el-dialog {
  border-radius: 14px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  padding: 18px 22px;
  background: linear-gradient(135deg, #f7fbff, #eef8f6);
  border-bottom: 1px solid #e4edf7;
}

::v-deep .el-dialog__body {
  padding: 20px 22px;
}

::v-deep .empty-tip {
  border: 1px dashed #cfe0f1;
  border-radius: 12px;
  background: #f8fbff;
}

@media (max-width: 960px) {
  .school-manage {
    padding: 12px;
  }

  ::v-deep .el-tabs {
    padding: 12px;
  }

  ::v-deep .school-class-page,
  ::v-deep .school-job-container .layout {
    flex-direction: column;
    height: auto !important;
  }

  ::v-deep .left-tree,
  ::v-deep .left-menu {
    width: 100% !important;
  }

  ::v-deep .student-btn-group {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
 /* .tableName{
	 width: 100%; 
  } */
}
</style>
